

import shader from "./shader/SnowShader"
class Snow {
    constructor(option) {
        option=option || {};
        this._speed = option.speed || 10.0;
        this._delegate = undefined;
    }

    set speed(speed) {
        this._speed = speed
        this._delegate && (this._delegate.uniforms.speed = speed)
        return this
    }

    get speed() {
        return this._speed
    }

    add() {
        if (this._delegate) {
            return;
        }

        this._delegate = new Cesium.PostProcessStage({
            fragmentShader: shader,
            uniforms: {
                speed: this._speed
            }
        })

        viewer.scene.postProcessStages.add(this._delegate)

    }

    remove() {

        if (this._delegate) {
            viewer.scene.postProcessStages.remove(this._delegate)
            this._delegate = undefined;
        }

    }
}

export default Snow;